import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

const ValidiformReact = ({ projectId, apiKey, apiUrl = 'https://api.validiform.com/api' }) => {

    useEffect(() => {
        if (typeof window !== "undefined") {

            if (!document.getElementById("validiform-recorder")) {
                const script = document.createElement('script');
                script.id = 'validiform-recorder';
                script.type = 'text/javascript';
                script.src = 'https://api.validiform.com/dist/browser/validiform-recorder.min.js';
                script.onload = function() {
                    console.log("Validiform Recorder script loaded successfully");
                    if (window.ValidiformRecorder) {
                        window.ValidiformRecorder.init({
                            apiUrl: apiUrl,
                            projectId: projectId,
                            apiKey: apiKey
                        });
                    }
                };
                
                document.getElementsByTagName("head")[0].appendChild(script);
            }
            
        }
    }, [projectId, apiKey, apiUrl]);

    return null;

}

ValidiformReact.propTypes = {
    projectId: PropTypes.string.isRequired,
    apiKey: PropTypes.string.isRequired,
    apiUrl: PropTypes.string,
}
 
export default ValidiformReact;